import React from "react";
import Form from "../common/form";
import { downloadFile } from "../../services/downloadService";
import {
  deleteProgramPendingProposalFiles,
  getProgramPendingProposalFiles,
  postTpsProviderDocument,
  saveApprovedFile,
  saveApprovedFileRename,
} from "../../services/getSonServices";
import {
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Box } from "@mui/system";
import { ListSubheader } from "@material-ui/core";
import fileNameOptions from "../common/sonFileNames.json";

class SonFilesTableRowForm extends Form {
  state = {
    data: {},
    submit: {},
    modalOpen: false,
    pendingFiles: {},
    approved: false,
    approveAsValue: "Default",
    approvedFileButton: true,
    fileNameOptions: [],
    fileExtension: "",
  };

  getFileExtension(filename) {
    if (!filename) return "";
    return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
  }

  async saveData(data) {
    await postTpsProviderDocument(data.id, data);
    if (typeof this.props.onSaveData === "function") {
      this.props.onSaveData();
    }
    if (data.id === 0) window.location.reload();
  }

  async getPendingFiles() {
    const { data } = await getProgramPendingProposalFiles(
      this.props.programId,
      this.props.fy
    );
    this.setState({ pendingFiles: data });
  }

  async componentDidMount() {
    const { data } = this.props;
    this.setState({ data, fileNameOptions: fileNameOptions.options });

    const fileExtension = this.getFileExtension(data.documentFile);

    this.setState({ fileExtension });

    await this.getPendingFiles();
  }

  setModalOpen(modalOpen) {
    this.setState({ modalOpen });
  }

  approveFile() {
    saveApprovedFile(
      this.props.programId,
      this.props.fy,
      this.state.data.documentFile
    );

    this.setState({ approved: true });

    this.setModalOpen(false);
    this.render();
  }

  async delteFile() {
    await deleteProgramPendingProposalFiles(
      this.props.programId,
      this.props.fy,
      this.state.data.documentFile
    );
    this.setModalOpen(false);
    // reload the page
    window.location.reload();
    this.render();
  }

  approveFileAs() {
    saveApprovedFileRename(
      this.props.programId,
      this.props.fy,
      this.state.data.documentFile,
      this.state.approveAsValue
    );
    this.setModalOpen(false);
    // reload the page
    window.location.reload();
    this.render();
  }

  handleApproveAsChange = (event) => {
    this.setState({ approveAsValue: event.target.value });
    if (event.target.value === "Default") {
      this.setState({ approvedFileButton: true });
    } else {
      this.setState({ approvedFileButton: false });
    }
  };

  render() {
    const {
      data,
      modalOpen,
      pendingFiles,
      approved,
      approveAsValue,
      fileExtension,
    } = this.state;
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      bgcolor: "white",
      borderRadius: "5px",
      boxShadow: 24,
      p: 4,
    };

    return (
      // HB: TODO - replace that 2023 with some kind of FY variable
      data.documentFile ? (
        <>
          <tr>
            <td className="px-2">
              <Button
                color={data.id === 0 ? "error" : "info"}
                onClick={() =>
                  downloadFile(
                    `son_docs~${this.props.fy}~${this.props.programId}`,
                    data.documentFile
                  )
                }
              >
                {data.documentFile}
              </Button>
            </td>
            <td className="px-2">{this.renderCheck("adminProvisional", "")}</td>
            <td className="px-2">{this.renderTextarea("notes", "")}</td>
            <td className="px-2">
              {pendingFiles.length > 0 &&
              pendingFiles?.toString().includes(data.documentFile) &&
              !approved ? (
                <Button
                  label={data.documentFile}
                  onClick={() => this.setModalOpen(true)}
                >
                  {data.documentFile}
                </Button>
              ) : (
                ""
              )}
            </td>
            <td className="px-2">
              <button
                className="btn btn-success"
                onClick={() => this.saveData(data)}
              >
                Save
              </button>
            </td>
          </tr>
          <tr>
            {modalOpen && (
              <Modal
                onClose={() => this.setModalOpen(false)}
                title="Review Submitted Document"
                open={modalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Button
                    onClick={() =>
                      downloadFile(
                        `son_docs_pending_review~${this.props.fy}~${this.props.programId}`,
                        data.documentFile
                      )
                    }
                  >
                    {data.documentFile}
                  </Button>

                  <br />
                  <br />
                  <button
                    id="approveDoc"
                    onClick={() => this.approveFile()}
                    className="btn btn-primary me-2"
                  >
                    Approve
                  </button>
                  <button
                    id="deleteDoc"
                    onClick={() => this.delteFile()}
                    className="btn btn-danger me-2"
                  >
                    Delete
                  </button>
                  <button
                    id="approveAS"
                    onClick={() => this.approveFileAs()}
                    className="btn me-2"
                    style={{ backgroundColor: "purple", color: "white" }}
                    disabled={this.state.approvedFileButton}
                  >
                    Approve As
                  </button>
                  <FormControl size="small" sx={{ minWidth: 250 }}>
                    <InputLabel id="approve-as-label">Approve AS</InputLabel>
                    <Select
                      labelId="approve-as-label"
                      value={approveAsValue}
                      label="Approve AS"
                      onChange={this.handleApproveAsChange}
                    >
                      <MenuItem value="Default">
                        Select a file {fileExtension}
                      </MenuItem>
                      {this.state.fileNameOptions.map((category) => [
                        <ListSubheader key={category.category}>
                          {category.category}
                        </ListSubheader>,
                        ...category.items.map((item) => (
                          <MenuItem
                            key={item.value}
                            value={this.props.sonId + "_" + item.label + "."+fileExtension}
                          >
                            {this.props.sonId + "_" + item.label + "."+fileExtension}
                          </MenuItem>
                        )),
                      ])}
                    </Select>
                  </FormControl>
                </Box>
              </Modal>
            )}
          </tr>
        </>
      ) : (
        <></>
      )
    );
  }
}

export default SonFilesTableRowForm;
